module.exports = __webpack_public_path__ + "img/coroprate1.png";